import request from '@/utils/request'

// 月汇总
export function listSummary(query) {
  return request({
    url: '/admi/summary/list',
    method: 'get',
    params: query,
    options: {
      loading: true,
      loadingText: '加载中...'
    }
  })
}
export function getSummary(id) {
  return request({
    url: '/admi/summary/' + id,
    method: 'get',
    options: {
      loading: true,
      loadingText: '加载中...'
    }
  })
}
export function updateSummary(data) {
  return request({
    url: '/admi/summary',
    method: 'put',
    data: data
  })
}
